import React, { useState, useEffect, useContext } from 'react';

import { buildDayPicker, buildYearPicker } from '../../_utils';

import { TranslationsContext } from "../../_contexts";

export default function IEDateTimePicker({ updateFormField, dateInputError }) {

  const translations = useContext(TranslationsContext);

  const date = new Date();

  const [month, setMonth] = useState("01");

  const [day, setDay] = useState("01");

  const [year, setYear] = useState(date.getFullYear());

  const [time, setTime] = useState("00");

  const [days, setDays] = useState(<></>);

  useEffect(() => {

    setDays(buildDayPicker(month));

  }, [month]);

  useEffect(() => {

    const value = year + "-" + month + "-" + day + "T" + time + ":00";

    updateFormField("properties._gcp_delivery_date", value);

  }, [day, month, year, time]);

  return (
    <>
      <div className={"gc__input_container"}>
        <label className={"gc__input_label"}>{translations.ie_date_picker_month}</label>
        <select
          className={dateInputError ? "gc__datetime_input gc__input_field gc__datetime_input_invalid" : "gc__input_field  gc__datetime_input"}
          onChange={(event) => setMonth(event.target.value)}
        >
          <option key="month_01" value="01">{translations.ie_month_select_jan}</option>
          <option key="month_02" value="02">{translations.ie_month_select_feb}</option>
          <option key="month_03" value="03">{translations.ie_month_select_mar}</option>
          <option key="month_04" value="04">{translations.ie_month_select_apr}</option>
          <option key="month_05" value="05">{translations.ie_month_select_may}</option>
          <option key="month_06" value="06">{translations.ie_month_select_jun}</option>
          <option key="month_07" value="07">{translations.ie_month_select_jul}</option>
          <option key="month_08" value="08">{translations.ie_month_select_aug}</option>
          <option key="month_09" value="09">{translations.ie_month_select_sep}</option>
          <option key="month_10" value="10">{translations.ie_month_select_oct}</option>
          <option key="month_11" value="11">{translations.ie_month_select_nov}</option>
          <option key="month_12" value="12">{translations.ie_month_select_dec}</option>
        </select>
      </div>
      <div className={"gc__input_container"}>
        <label className={"gc__input_label"}>{translations.ie_date_picker_day}</label>
        <select
          className={dateInputError ? "gc__datetime_input gc__input_field gc__datetime_input_invalid" : "gc__input_field  gc__datetime_input"}
          onChange={(event) => setDay(event.target.value)}
        >
          {days}
        </select>
      </div>
      <div className={"gc__input_container"}>
        <label className={"gc__input_label"}>{translations.ie_date_picker_year}</label>
        <select
          className={dateInputError ? "gc__datetime_input gc__input_field gc__datetime_input_invalid" : "gc__input_field  gc__datetime_input"}
          onChange={(event) => setYear(event.target.value)}
        >
          {buildYearPicker()}
        </select>
      </div>
      <div className={"gc__input_container"}>
        <label className={"gc__input_label"}>{translations.ie_date_picker_hour}</label>
        <select
          className={dateInputError ? "gc__datetime_input gc__input_field gc__datetime_input_invalid" : "gc__input_field  gc__datetime_input"}
          onChange={(event) => setTime(event.target.value)}
        >
          <option key="time_00" value="00">00:00</option>
          <option key="time_01" value="01">01:00</option>
          <option key="time_02" value="02">02:00</option>
          <option key="time_03" value="03">03:00</option>
          <option key="time_04" value="04">04:00</option>
          <option key="time_05" value="05">05:00</option>
          <option key="time_06" value="06">06:00</option>
          <option key="time_07" value="07">07:00</option>
          <option key="time_08" value="08">08:00</option>
          <option key="time_09" value="09">09:00</option>
          <option key="time_10" value="10">10:00</option>
          <option key="time_11" value="11">11:00</option>
          <option key="time_12" value="12">12:00</option>
          <option key="time_13" value="13">13:00</option>
          <option key="time_14" value="14">14:00</option>
          <option key="time_15" value="15">15:00</option>
          <option key="time_16" value="16">16:00</option>
          <option key="time_17" value="17">17:00</option>
          <option key="time_18" value="18">18:00</option>
          <option key="time_19" value="19">19:00</option>
          <option key="time_20" value="20">20:00</option>
          <option key="time_21" value="21">21:00</option>
          <option key="time_22" value="22">22:00</option>
          <option key="time_23" value="23">23:00</option>
        </select>
      </div>
    </>
  )

};
